var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInvoicesSkeletonDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 1160 527"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "url(#invoices-skeleton-desktop_svg__b)",
  clipPath: "url(#invoices-skeleton-desktop_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 300,
  height: 50,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 1160,
  height: 257,
  y: 270,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 260,
  height: 50,
  x: 900,
  rx: 25
}), /*#__PURE__*/React.createElement("rect", {
  width: 460,
  height: 27.5,
  y: 90,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 460,
  height: 27.5,
  y: 127.5,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 460,
  height: 27.5,
  y: 165,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 531,
  height: 27.5,
  y: 202.5,
  rx: 5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "invoices-skeleton-desktop_svg__b",
  x1: 0,
  x2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "white; #F7F7F7; white;"
})), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F7F7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "#F7F7F7; white; #F7F7F7;"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "gradientTransform",
  dur: "3s",
  from: "0 0 0",
  repeatCount: "indefinite",
  to: "0 0 0",
  type: "translate"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "invoices-skeleton-desktop_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1160v527H0z"
})))));
export { SvgInvoicesSkeletonDesktop as ReactComponent };
export default __webpack_public_path__ + "static/media/invoices-skeleton-desktop.832b4d0c1772885e9534.svg";